import React from "react";
import ConceptComponent from "../ConceptComponent";

function ConceptSection() {
  return (
    <section className="pt-4 pb-12 md:pt-6 md:pb-20 flex items-center">
      <div className="container">
        <div className="wrap">
          <ConceptComponent />
        </div>
      </div>
    </section>
  );
}

export default ConceptSection;
